import React, { useEffect, useState } from 'react'
import { axiosapi } from '../../api/axiosapi'
import BusCardComponent from './BusCardComponent';
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const MyBus = (props) => {
    const axiosPrivate = useAxiosPrivate();
    const [busdata, setbusdata] = useState([])
    useEffect(() => {
        const getBuses = async () => {
            const response = await axiosPrivate.post('/bus/getbusbyoperator', { userid: props.userid })
            setbusdata(response.data.buses)
            console.log(response.data.buses)
        }
        getBuses();

    }, [])
    return (
        <>
            {
                busdata?.map((x) => (
                    < BusCardComponent busdata={x} />
                ))
            }
        </>

    )
}

export default MyBus
